(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/views/peppbubbles.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/views/peppbubbles.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
svs.numbergames.results.views.Peppbubbles = Marionette.View.extend({
  bubbles: [],
  template(data) {
    return svs.numbergames.results.templates.peppbubbles(data);
  },
  templateContext() {
    return {
      bubbles: this.bubbles
    };
  },
  onBeforeRender() {
    const productId = this.model.get('productId');
    let jackpot;
    if (svs.numbergames.productMapping.isLotto(productId)) {
      var _svs$numbergames$resu;
      jackpot = (_svs$numbergames$resu = svs.numbergames.results.jackpotsRadio) === null || _svs$numbergames$resu === void 0 ? void 0 : _svs$numbergames$resu.request('jackpotInfo', 'dromvinst');
    } else if (!svs.numbergames.productMapping.isKeno(productId)) {
      var _svs$numbergames, _svs$numbergames2;
      jackpot = {
        defaultJackpot: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 || (_svs$numbergames = _svs$numbergames.results.jackpotsRadio) === null || _svs$numbergames === void 0 ? void 0 : _svs$numbergames.request('jackpotInfo', 'defaultJackpot'),
        jackpotAmountString: (_svs$numbergames2 = svs.numbergames) === null || _svs$numbergames2 === void 0 || (_svs$numbergames2 = _svs$numbergames2.results.jackpotsRadio) === null || _svs$numbergames2 === void 0 ? void 0 : _svs$numbergames2.request('jackpotInfo', 'jackpotAmountString')
      };
    }
    this.bubbles = svs.numbergames.results_common.helpers.peppbubbles.getPeppbubbles(_objectSpread(_objectSpread({}, this.model.toObject()), {}, {
      jackpot
    }));
  },
  onRender() {
    this.bubbles.forEach((bubble, index) => {
      const regionId = "peppbubble".concat(index, "Region");
      this.addRegion(regionId, "#".concat(regionId));
      this.showChildView(regionId, {
        className: index ? '' : 'margin-bottom-2',
        template: () => bubble
      });
    });
  }
});

 })(window);